module.exports = __webpack_public_path__ + "static/media/complete.a951ba7c.svg";